<template>
    <v-card color="primary" class="pt-2 pb-0 px-0" flat rounded="0">
        <v-container class="pb-0">
            <v-card-title class="d-flex justify-space-between">
                <div class="d-flex">
                    <v-img
                        class="ufv-toolbar-logo"
                        src="../../assets/logotipoUFV2.png"
                        alt="ufv"
                    />
                </div>
                <div class="flex-grow-1 d-flex justify-end px-6 align-end mt-8">
                    <div>
                        <caixa-contexto
                            :value="contexto"
                            @input="onContextChange"
                            dark
                        />
                    </div>
                </div>

                <v-btn v-if="!isAuthenticated" small @click="login"
                    ><v-icon>mdi-login</v-icon>Entrar</v-btn
                >
                <div v-if="isAuthenticated">
                    <display-usuario v-if="!mobile" />
                    <menu-mobile v-if="mobile" />
                </div>
            </v-card-title>
            <v-tabs
                background-color="transparent"
                v-if="!mobile"
                active-class="ufv-app-bar-tab-active"
            >
                <v-tabs-slider color="#eee"></v-tabs-slider>
                <v-tab class="ufv-app-bar-tab" to="/">Home</v-tab>
                <v-tab
                    class="ufv-app-bar-tab"
                    to="/atendimento"
                    v-show="isAuthenticated"
                    >Novo Chamado</v-tab
                >
                <v-tab
                    class="ufv-app-bar-tab"
                    to="/chamados/abertos"
                    v-show="isAuthenticated"
                    ><v-badge
                        inline
                        :content="numAbertosNaoVisualizados + ' novos'"
                        :value="numAbertosNaoVisualizados"
                    >
                        Chamados Abertos
                    </v-badge></v-tab
                >
                <v-tab
                    class="ufv-app-bar-tab"
                    to="/chamados/fechados"
                    v-show="isAuthenticated"
                    ><v-badge
                        inline
                        :content="numFechadosNaoVisualizados + ' novos'"
                        :value="numFechadosNaoVisualizados"
                    >
                        Chamados Fechados
                    </v-badge></v-tab
                >
                <v-tab
                    class="ufv-app-bar-tab"
                    to="/chamados/buscar"
                    v-show="isAuthenticated"
                >
                    Buscar Chamados
                </v-tab>
                <v-tab class="ufv-app-bar-tab" to="/admin" v-show="isAdmin"
                    >Administração</v-tab
                >
            </v-tabs>
        </v-container>
        <modal v-model="modalContexto" titulo="Aviso">
            <p>
                O Sistema Chamado agora é usado por vários departamentos. Por
                isso, agora é necessário escolher o departamento na qual você
                deseja visualizar ou abrir uma solicitação.
            </p>
            <p>
                Desta forma, pedimos que escolha o departamento na caixa abaixo.
                Você sempre poderá trocar o depatamento na parte superior da
                tela.
            </p>
            <p>
                E lembre-se: este é o departamento onde você quer acompanhar os
                chamados e NÃO o departamento onde você trabalha!
            </p>
            <div>
                <caixa-contexto :value="contexto" @input="onContextChange" />
            </div>
        </modal>
    </v-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { INTERVALO_ATUALIZACAO_MS } from "../../utils/general";
import CaixaContexto from "../../componentes/contexto/CaixaContexto";
import Modal from "../../componentes/Modal";
import DisplayUsuario from "../../componentes/DisplayUsuario.vue";
import MenuMobile from "../../componentes/MenuMobile.vue";

export default {
    components: {
        "caixa-contexto": CaixaContexto,
        modal: Modal,
        "display-usuario": DisplayUsuario,
        "menu-mobile": MenuMobile,
    },
    data() {
        return {
            interval: null,
            modalContexto: false,
        };
    },
    mounted() {
        this.modalContexto = this.contexto == null;
        this.atualizarVisualizacoes();
        this.interval = setInterval(() => {
            this.atualizarVisualizacoes();
        }, INTERVALO_ATUALIZACAO_MS);
    },
    destroyed() {
        clearInterval(this.interval);
    },
    computed: {
        ...mapGetters("autenticacao", [
            "isAuthenticated",
            "isAdmin",
            "identidadeEfetiva",
        ]),
        ...mapGetters("visualizacoes", [
            "numAbertosNaoVisualizados",
            "numFechadosNaoVisualizados",
        ]),
        ...mapGetters("contexto", ["contexto"]),
        mobile: function () {
            return this.$vuetify.breakpoint.smAndDown;
        },
    },
    watch: {
        isAuthenticated(isAuth) {
            if (isAuth) {
                this.atualizarVisualizacoes();
            }
        },
        "identidadeEfetiva.id"(novo, antigo) {
            if (novo !== antigo) {
                this.atualizarVisualizacoes();
            }
        },
    },
    methods: {
        ...mapActions("autenticacao", {
            login: "LOGIN",
            logout: "LOGOUT",
        }),
        ...mapActions("visualizacoes", ["atualizarVisualizacoes"]),
        ...mapActions("contexto", ["setContexto"]),
        onContextChange(contexto) {
            this.modalContexto = false;
            this.setContexto(contexto);
            this.$servicoAtendimento.cancelar();
            this.atualizarVisualizacoes();
        },
    },
};
</script>
<style scoped>
.ufv-toolbar-logo {
    max-width: 100px;
}
.ufv-app-bar-actions {
    gap: 16px;
}
.ufv-app-bar-tabsX {
    margin-top: 10px;
    margin-left: 10%;
    margin-right: 10%;
}
.ufv-app-bar-tab {
    background-color: white;
    border-radius: 5px 5px 0px 0px;
    margin-right: 10px;
}

.ufv-app-bar-tab-active {
    background-color: #eee;
    color: #682a2c;
}
</style>
